<template>
    <div class="feature-request-container">
        <h3 class="mt-0 font-size-150 font-weight-normal">
            {{ header }}
        </h3>
        <p>{{ description }}</p>
        <div class="d-flex flex-column gap-20">
            <TextArea
                id="comment"
                name="comment"
                v-model="comment"
                :value="comment"
                :border-class="'br-4'"
                :max-characters="280"
                :rows="'3'"
                :aiCustom="true"
                class="w-100 feature-request-text-area"
                :id="'feature-request-form-textarea'"
                type="text"
                v-if="!commentSent"
            ></TextArea>
            
            <div class="alert alert-warning m-0" v-if="errorCommentEmpty">
                {{ translate('Please enter your feedback!') }}
            </div>

            <div v-if="!commentSent" class="d-flex justify-content-between align-items-center">
                <button 
                    class="btn btn-success feature-request-submit-btn"
                    :class="{ 'disabled': loading === true }"
                    @click.prevent="submit"
                >
                    {{ translate("Submit") }}
                    <i v-if="!loading" class="far fa-comment"></i>
                    <i v-if="loading" class="fa fa-spin btn-loading-animation"></i>
                </button>

                <label class="m-0 d-flex align-items-center gap-10">
                    <input
                        type="checkbox"
                        @change="dismiss"
                    />
                    {{ translate('Don\'t ask again') }}
                </label>
            </div>

            <div class="alert alert-info m-0" v-if="loading === true">
                {{ translate('Submitting your feedback..') }}
              </div>
            
            <span class="alert alert-info m-0" v-if="commentSent">
                <i class="fa fa-check"></i> {{ translate("Feedback sent") }}
            </span>
            
        </div>
    </div>
</template>

<script>
import FeatureRequestManager from "../../manager/FeatureRequestManager";
import {satGlobals} from "../../../../../../sat/helper/sat-globals";
import Analytics from "../../util/Analytics";
import TextArea from "../../../form/TextArea.vue";
import { translate } from "../../../../../../helper/translate";

export default {
    name: "FeatureRequestForm",
    props: {},
    components: { TextArea },
    mixins: [],
    data() {
      return {
        comment: '',
        commentSent: false,
        errorCommentEmpty: false,
        loading: false,
        header: translate(`What do you want to see on ${satGlobals.getProjectName()} next year?`),
        description: translate(`We constantly improve ${satGlobals.getProjectName()} with the help of your feedback. What features would you like to have included next year?`)
      };
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
        async submit() {
            if (this.comment === '') {
                this.errorCommentEmpty = true;
                return;
            }

            this.errorCommentEmpty = false;
            this.loading = true;

            Analytics.send('result_feature-request', 'comment', this.comment);

            await FeatureRequestManager.submitFeatureRequest(this.comment)
                .then(() => {
                    this.loading = false;
                    this.commentSent = true;
                });
        },
        dismiss() {
            FeatureRequestManager.dismiss();
        }
    },
    computed: {}
};
</script>

<style lang="scss" scoped>
.feature-request-container {
    background: white;
    border: 1px solid #CBCBCB;
    border-radius: 4px;
    padding: 20px;
}

.feature-request-text-area {
    padding-bottom: 3px;
    background: #fff;
    color: #2e2e2e;
    position: relative;
    border-radius: 5px;
    border: 1px solid #CBCBCB;
  
    textarea {
      font-size: 18px !important;
      margin: 40px 20px 0 20px !important;
      padding: 0;
      overflow: auto;
  
      &::-webkit-scrollbar {
        display: none;
      }
  
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
}

.feature-request-submit-btn {
    background: #1266F1;
    color: white;
    align-items: center;
    display: flex;
    height: 38px;
    gap: 10px;
    padding: 0 10px 0 10px;
    font-weight: 600;
}
</style>
  